import img1 from "../../assets/images/case_study/1.png";
import img2 from "../../assets/images/case_study/2.png";
import Frame from "../../assets/images/CaseStudyImagesV2/Frame-1.png";
import Frame3 from "../../assets/images/CaseStudyImagesV2/Frame-3.png";
import Frame2 from "../../assets/images/CaseStudyImagesV2/Frame-2.png";
import Frame4 from "../../assets/images/CaseStudyImagesV2/Frame.png";
import Frame5 from "../../assets/images/CaseStudyImagesV2/Frame-4.png";
import Frame6 from "../../assets/images/CaseStudyImagesV2/Frame-6.png";
import Frame7 from "../../assets/images/CaseStudyImagesV2/Frame8.png";
import Frame8 from "../../assets/images/CaseStudyImagesV2/Frame9.png";
import Frame9 from "../../assets/images/CaseStudyImagesV2/Frame10.png";
import Frame10 from "../../assets/images/CaseStudyImagesV2/Frame11.png";
import Frame11 from "../../assets/images/CaseStudyImagesV2/Frame12.png";
import Frame12 from "../../assets/images/CaseStudyImagesV2/Frame13.png";
import Frame13 from "../../assets/images/CaseStudyImagesV2/Frame14.png";
// Artwork added from Figma onwards is uploaded to S3 rather than committed, so
// the bundle does not carry full-size photography.
const S3 = "https://website-landing-page-np.s3.ap-south-1.amazonaws.com";

// MagMax case studies, exported from Figma 12050:3496 and 12050:3685.
const fsmHero = `${S3}/20261007103158_fsm-hero.png`;
const carbideHero = `${S3}/20261007103213_carbide-hero.png`;
const carbideBaseline = `${S3}/20261007103227_carbide-baseline-micrograph.png`;
const carbideResult1 = `${S3}/20261007103228_carbide-result-1.png`;
const carbideResult2 = `${S3}/20261007103229_carbide-result-2.png`;
// Like the Titagarh badges below, each of these is a complete 64px disc, so
// they are flagged `iconFull` and render without the CSS circle.
const icBrittleness = `${S3}/20261007103229_ic-brittleness.png`;
const icRapidCooling = `${S3}/20261007103229_ic-rapid-cooling.png`;
const icEconomicCost = `${S3}/20261007103229_ic-economic-cost.png`;
const icProvenSolution = `${S3}/20261007103230_ic-proven-solution.png`;
const icEconomicBenefits = `${S3}/20261007103230_ic-economic-benefits.png`;
const icEnhancedQuality = `${S3}/20261007103230_ic-enhanced-quality.png`;
const icFutureImpact = `${S3}/20261007103230_ic-future-impact.png`;

// Titagarh badges exported from Figma 11950:31511.
const TITAGARH_ICONS = S3;
const TgThroughput = `${TITAGARH_ICONS}/20261006112005_h1-throughput.png`;
const TgDelivery = `${TITAGARH_ICONS}/20261006112005_h2-delivery.png`;
const TgCost = `${TITAGARH_ICONS}/20261006112005_h3-cost.png`;
const TgTraceability = `${TITAGARH_ICONS}/20261006112006_h4-traceability.png`;
const TgQuality = `${TITAGARH_ICONS}/20261006112006_h5-quality.png`;
const TgEnergy = `${TITAGARH_ICONS}/20261006112006_h6-energy.png`;
const TgWorkflow = `${TITAGARH_ICONS}/20261006112006_s1-workflow.png`;
const TgVisibility = `${TITAGARH_ICONS}/20261006112006_s2-visibility.png`;
const TgAiIot = `${TITAGARH_ICONS}/20261006112007_s3-aiiot.png`;
const TgSafety = `${TITAGARH_ICONS}/20261006112007_s4-safety.png`;


export const CASE_STUDIES = [
  // Figma 12050:3496 — Case Study Page - R.B. Agarwalla (FSM Addition Rate)
  {
    title: "REDUCTION OF FSM ADDITION RATE",
    cardTitle: "FOUNDRY CUTS FSM COST BY ₹7.02 LAKH A YEAR",
    client: "R.B. Agarwalla & Co. Pvt. Ltd.",
    publishedOn: "27th April, 2026",
    category: "Raw Material",
    image: fsmHero,
    description:
      "Switching to MagMax FS10 reduced the foundry’s FSM addition rate and lifted nodularity from 87% to 92%, saving ₹58,500 a month - ₹7.02 lakh annually.",
    sections: [
      {
        type: "text",
        heading: "NowPurchase FSM (MagMax FS10)",
        content:
          "NowPurchase FSM (MagMax FS10) is a TRE-based Mg: 9–10% grade ferro-silicon-magnesium (FSM) used for nodularizing ductile iron, engineered to provide better recovery, higher nodularity%, higher nodule count, a better ferrite–pearlite ratio, and castings free from iron carbide.",
      },
      {
        type: "specs",
        items: [
          { label: "Magnesium", value: "9–10%" },
          { label: "Silicon", value: "45–48%" },
          { label: "Calcium", value: "1.8–2%" },
          { label: "Total rare earth", value: "1.7–2%" },
          { label: "Aluminium", value: "1% max" },
        ],
      },
      {
        type: "table",
        variant: "comparison",
        heading: "Comparative Study: Existing FSM vs MagMax FS10",
        headers: ["Parameter", "Akshit Enterprises FSM", "MagMax FS10"],
        rows: [
          ["Carbon", "3.85%", "3.78%"],
          ["Silicon", "2.87%", "2.73%"],
          ["Manganese", "0.35%", "0.36%"],
          ["Phosphorus", "0.082%", "0.084%"],
          ["Sulphur", "0.017%", "0.014%"],
          ["Magnesium", "0.038%", "0.043%"],
          ["Nodularity", "87%", "92%"],
          ["Nodule count", "264", "306"],
          ["FSM used", "11.5 kg", "11 kg"],
          ["Tapping temperature", "1572°C", "1572°C"],
          ["Pouring time", "09 min 37 sec", "09 min 56 sec"],
        ],
      },
      {
        type: "text",
        heading: "Trial report",
        content:
          "With this trial, we have successfully reduced their FSM addition rate by 0.05%; i.e. by 500 kg in 1 M.T. liquid metal.\n\nBy this, we have saved them Rs. 58, 500 per month; which complies to a savings Rs. 7, 02, 000 per year.",
      },
      {
        type: "note",
        content:
          "NowPurchase FSM (MagMax FS10) has been performing consistently well at R.B. Agarwalla & Co. Pvt. Ltd., with feedback from the plant’s laboratory and process control team calling it the best FSM used at the facility so far.",
      },
    ],
  },

  // Figma 12050:3685 — Case Study Page - Hari Om Casting (MagMax La)
  {
    title: "ELIMINATING IRON CARBIDE IN THIN-SECTION CASTINGS",
    cardTitle: "0% IRON CARBIDE IN A 3 MM SECTION CASTING",
    client: "Hari Om Casting Co. Pvt. Ltd. — using MagMax (La)",
    publishedOn: "27th April, 2026",
    category: "Raw Material",
    image: carbideHero,
    hideHeroImage: true,
    description:
      "MagMax (La) replaced TRE-based Fe-Si-Mg on a 500/7 manhole cover, cutting iron carbide from 15-20% by volume to zero in a 3 mm section.",
    sections: [
      {
        type: "cards",
        heading: "The Challenge: Iron Carbide in Thin-Section Castings",
        columns: 3,
        items: [
          {
            iconImage: icBrittleness,
            iconFull: true,
            title: "Brittleness & Impact",
            description:
              "Formation of brittle iron carbide reduces ductility, machinability, and impact strength.",
          },
          {
            iconImage: icRapidCooling,
            iconFull: true,
            title: "Rapid Cooling",
            description:
              "Thin sections with cooling rates exceeding 100°C/sec exacerbate carbide formation.",
          },
          {
            iconImage: icEconomicCost,
            iconFull: true,
            title: "Economic Cost",
            description:
              "Up to 15% scrap rate and significant re-processing expenses due to carbide presence.",
          },
        ],
      },
      {
        type: "imageText",
        heading: "Traditional Solution & Limitations",
        image: carbideHero,
        imageAlt: "TRE-based Fe-Si-Mg granules",
        points: [
          {
            label: "TRE-based Fe-Si-Mg:",
            text: "Standard for graphite nodulization and neutralizing subversive elements.",
          },
          {
            label: "Composition:",
            text: "Typically contains 0.8–2% rare earth, primarily Cerium (Ce) and Lanthanum (La).",
          },
          {
            label: "Challenge in Thin Sections:",
            text: "High Ce content can paradoxically promote carbide formation in very thin sections, undermining desired properties.",
          },
        ],
      },
      {
        type: "cards",
        heading: "The Innovation: La-Based Fe-Si-Mg",
        columns: 4,
        items: [
          {
            title: "Optimized Alloy",
            description:
              "Engineered with 0.4–0.6% La, with no Ce or other rare earth elements.",
          },
          {
            title: "Reduced Chilling",
            description:
              "Promotes graphite formation over carbide, even in fast-cooling environments.",
          },
          {
            title: "Higher Affinity",
            description:
              "La has a stronger affinity for oxygen and sulphur than Ce, for more effective neutralization.",
          },
          {
            title: "Target Application",
            description:
              "Specifically for thin-wall ductile iron components like automotive brackets and hydraulic parts.",
          },
        ],
      },
      {
        type: "mechanism",
        heading: "Metallurgical Mechanism of Lanthanum",
        items: [
          {
            title: "Potent Deoxidizer & Desulfurizer",
            description:
              "Lanthanum forms stable La₂O₃ and La₂S₃, effectively removing detrimental elements from the melt.",
          },
          {
            title: "Optimized Graphite Nucleation",
            description:
              "Provides ideal nucleation sites for the formation of spherical graphite, actively suppressing harmful carbide structures.",
          },
          {
            title: "Subversive Element Neutralization",
            description:
              "Effectively neutralizes elements like Bismuth, Titanium, and Lead, known to promote chilling and disrupt nodule formation.",
          },
          {
            title: "Improved Melt Quality",
            description:
              "Enhances melt fluidity and reduces non-metallic oxide inclusions, leading to cleaner, higher-quality castings.",
          },
        ],
      },
      {
        type: "paramPanel",
        heading: "Case Study: Eliminating Carbides in Thin-Section Castings",
        points: [
          {
            label: "Casting Type:",
            text: "500/7 ductile iron manhole cover with minimum section thickness 3 mm.",
          },
          {
            label: "Baseline (TRE-based Fe-Si-Mg):",
            text: "Standard Fe-Si-Mg (1.85% TRE, 1.11% Ce, 0.65% La) resulted in 15–20% carbide by volume.",
          },
          {
            label: "Experimental Setup:",
            text: "Replaced with La-based Fe-Si-Mg (0.5% La) at consistent addition rates.",
          },
          {
            label: "Objective:",
            text: "Achieve carbide-free microstructure (matrix structure) with target mechanical properties.",
          },
        ],
        image: carbideBaseline,
        imageAlt: "Baseline micrograph showing iron carbide",
        panelTitle: "Melt Parameters",
        params: [
          { label: "Pig iron used", value: "400 kg" },
          { label: "Ba-based ladle inoculant", value: "4 kg" },
          { label: "MS scrap used", value: "200 kg" },
          { label: "Liquid metal tapped", value: "1000 kg" },
          { label: "Foundry return used", value: "400 kg" },
          { label: "Tapping temperature", value: "1550°C approx." },
          { label: "La-based FSM used", value: "11 kg" },
          { label: "Pouring time", value: "10 minutes approx." },
        ],
      },
      {
        type: "gallery",
        heading: "Results: 0% Iron Carbide in the Matrix Structure",
        images: [
          { src: carbideResult1, alt: "Matrix structure micrograph, etched" },
          { src: carbideResult2, alt: "Matrix structure micrograph, as-polished" },
        ],
      },
      {
        type: "cards",
        heading: "Conclusion: A Paradigm Shift for Thin-Wall Castings",
        columns: 4,
        items: [
          {
            iconImage: icProvenSolution,
            iconFull: true,
            title: "Proven Solution",
            description:
              "La-based Fe-Si-Mg effectively eliminates carbides in thin-section castings.",
          },
          {
            iconImage: icEconomicBenefits,
            iconFull: true,
            title: "Economic Benefits",
            description:
              "Significantly reduces scrap, re-work, and overall production costs.",
          },
          {
            iconImage: icEnhancedQuality,
            iconFull: true,
            title: "Enhanced Quality",
            description:
              "Delivers superior ductility and machinability for demanding applications.",
          },
          {
            iconImage: icFutureImpact,
            iconFull: true,
            title: "Future Impact",
            description:
              "Enables production of lighter, more complex ductile iron components.",
          },
        ],
      },
    ],
  },

  {
    title: "5% BOOST IN STEEL FOUNDRY'S PROFITABILITY AND PRODUCTIVITY",
    publishedOn: "27th April, 2026",
    category: "MetalCloud",
    image: img1,
    description:
      "MetalCloud helped a Pune-based steel foundry achieve a 5% boost in profitability through data-driven charge mix optimization and procurement strategy.",
    sections: [
      {
        type: "highlights",
        items: [
          {
            iconImage: Frame,
            value: "5%",
            description:
              "Boost in steel foundry's profitability &\nproductivity",
          },
          {
            iconImage: Frame3,
            value: "4%",
            description: "Reduction in\ncost of production",
          },
          {
            iconImage: Frame2,
            value: "95%",
            description: "Reduction in\naddition/dilution",
          },
          {
            iconImage: Frame4,
            value: "7%",
            description: "Reduction in\nmelting time",
          },
          {
            iconImage: Frame5,
            value: "7%",
            description: "Reduction in\nPurchase Costs",
          },
          {
            iconImage: Frame6,
            value: "5%",
            description: "Reduction in\nElectricity Costs",
          },
        ],
      },
      {
        type: "text",
        heading: "Client Summary",
        content:
          "The Pune based company has developed a foundry unit for steel and alloy steel. Their primary end goal is to manufacture high-quality steel, alloy steel, duplex, super duplex and super alloy casting. Their clients include pump, brakes, valve and other engineering industries to whom they supply promptly and at a competitive price. The organisation is empowered with sound technical manpower which are guided by expert metallurgical management to achieve end customer requirement.",
      },
      {
        type: "text",
        heading: "Project Summary",
        content:
          "The firm is one of the leading producers of steel and alloy steel castings in Western India. As a legacy business, the company significantly relied on the expertise of metallurgists, production managers, and intuition. The business relied on manual methods of procurement, charge mix creation, and addition/dilution processes.\n\nMetalCloud intervened to implement a production-driven procurement strategy, production planning, and the streamlining of the melting process in order to facilitate the company's digital transformation of its production and procurement operations.",
      },
      {
        type: "solutions",
        items: [
          {
            iconImage: Frame7,
            title: "MetalCloud Platform",
            description: "to generate optimised charge mixes",
          },
          {
            iconImage: Frame8,
            title: "Spectrometer Integrations",
            description: "for automated Additions/Dilution suggestions",
          },
          {
            iconImage: Frame9,
            title: "Purchaser\nPanel",
            description:
              "to make intelligent decisions on procurement of raw materials",
          },
          {
            iconImage: Frame10,
            title: "Real Time Notifications",
            description: "on molten metal\nproperties",
          },
        ],
      },
      {
        type: "testimonial",
        quote:
          "\u201cWith MetalCloud, we were able to generate all of our alloy inventory at the lowest possible cost while ensuring quality and eliminating calculation errors. It has also allowed us to easily adjust our pricing to meet the needs of customers. We were able to adjust our material purchases without anxiety thanks to MetalCloud.\n\nMetalCloud has revamped our purchasing decision by comparing the materials in the market to find appropriate raw materials for our operations\u201d",
        author: "Director, Foundry Division",
      },
    ],
  },

  {
    title: "KOLHAPUR FOUNDRY REDUCES MELTING COSTS BY \u20b91.7 Cr ANNUALLY",
    publishedOn: "27th April, 2026",
    category: "MetalCloud",
    image: img2,
    description:
      "Through a 4-day trial using MetalCloud\u2019s charge mix optimization, the foundry achieved \u20b9456.50 per tonne savings with an annual impact of \u20b91.7 Crore.",
    sections: [
      {
        type: "highlights",
        items: [
          {
            iconImage: Frame11,
            title: "Efficient Melting",
            description: "25% reduction\nin Pig Iron usage",
          },
          {
            iconImage: Frame12,
            iconAlt: "recycling",
            title: "Sustainable Melt",
            description:
              "Boost in steel foundry\u2019s profitability &\nproductivity",
          },
          {
            iconImage: Frame,
            title: "Cost Efficiency",
            description: "Reduction in addition\n/dilution",
          },
          {
            iconImage: Frame3,
            title: "Annual Savings",
            description: "Reduction in cost of\nproduction",
          },
          {
            iconImage: Frame13,
            iconAlt: "warranty-card",
            iconSize: 48,
            title: "Quality Assurance",
            description: "Reduction in\nPurchase Costs",
          },
        ],
      },
      {
        type: "text",
        heading: "Client Summary",
        content:
          "A leading integrated foundry in Kolhapur, catering to the automotive and industrial sectors. With an annual production of 37,200 tonnes, the foundry operates with modern induction furnaces and automated molding lines and supplies high-quality castings to domestic and global OEMs.",
      },
      {
        type: "text",
        heading: "Project Summary",
        content:
          "The trial was carried out over a period of four days across multiple heats, with the primary objective of reducing melting costs while maintaining strict chemistry compliance. Leveraging MetalCloud\u2019s charge mix optimization tool, the team adjusted the proportions of bulk materials and ferro alloys, systematically collected and analyzed bath, ladle, and final samples, and validated the model\u2019s predictions against the actual trial results.",
      },
      {
        type: "table",
        heading: "Chargemix Comparison (per tonne)",
        headers: ["Material", "Current", "Optimised"],
        rows: [
          ["MS Scrap", "605", "605"],
          ["Pig Iron", "40", "80"],
          ["DI Return in-house", "300", "330"],
          ["CRC", "0", "60"],
          ["FeSi", "4", "3"],
          ["FeMn", "2", "2"],
          ["FeCr", "2", "2"],
          ["Inoculant - GI", "2.6", "2.6"],
        ],
      },
      {
        type: "table",
        heading: "Cost Saving",
        headers: [
          "Parameter",
          "Current",
          "Optimised (Predicted)",
          "Actual Achieved",
        ],
        rows: [
          ["Material (\u20b9)", "33,033", "32,553.50", "32,576.50"],
          [
            { value: "Per Tonne Saving : \u20b9456.50", colSpan: 2 },
            {
              value: "Annual Saving (37,200 tonnes): \u20b91.7 Crore",
              colSpan: 2,
            },
          ],
        ],
      },
      {
        type: "table",
        heading: "Chemistry Validation",
        headers: [
          "Parameter",
          "Target Range",
          "Final (Achieved)",
          "Bath (Achieved)",
        ],
        rows: [
          ["C", "3.1 - 3.4", "3.389", "3.237"],
          ["Si", "1.7 - 1.9", "1.749", "1.589"],
          ["Mn", "0.8 - 1.0", "0.761", "0.758"],
          ["S", "0.07 - 0.3", "0.064", "0.073"],
          ["P", "< 0.1", "0.036", "0.050"],
          ["Cr", "0.3 - 0.4", "0.334", "0.314"],
        ],
      },
      {
        type: "solutions",
        items: [
          {
            iconImage: Frame7,
            title: "MetalCloud Platform",
            description: "to generate optimised charge mixes",
          },
          {
            iconImage: Frame8,
            title: "Spectrometer Integrations",
            description: "for automated Additions/Dilution suggestions",
          },
          {
            iconImage: Frame9,
            title: "Purchaser\nPanel",
            description:
              "to make intelligent decisions on procurement of raw materials",
          },
          {
            iconImage: Frame10,
            title: "Real Time Notifications",
            description: "on molten metal\nproperties",
          },
        ],
      },
      {
        type: "testimonial",
        quote:
          "\u201cThe 4-day trial gave us valuable insights into our melting process. Based on the trial\u2019s cost savings, we will now be able to save around \u20b91.7 Cr annually while maintaining stable metallurgical performance. MetalCloud has given us the confidence to run our melts in a more scientific and data-driven way.\u201d",
        author: "Foundry Director",
      },
    ],
  },

  {
    title:
      "East India’s Leading Railway Wagon & Heavy Engineering Manufacturer Accelerates Throughput with AI-Led Foundry Digitisation",
    publishedOn: "29th September, 2026",
    category: "MetalCloud",
    // Hero art exported from Figma 11950:31515 at 2x. The earlier file was a
    // different grade of the same render - dark grey backdrop instead of the
    // white one the design uses - so it read as a different image on the page.
    image:
      "https://website-landing-page-np.s3.ap-south-1.amazonaws.com/20261006112614_titagarh-hero.jpg",
    // Same artwork re-framed for the listing card. The hero is 2.53:1 to fill
    // the detail page's 600px band; the card is nearer 3:2, and `cover` was
    // cutting the nose and the tail off the train. This one is 3:2 - at or
    // below every card aspect, so `cover` trims height only - with the train
    // spanning the full width so it meets both card edges.
    thumbnail:
      "https://website-landing-page-np.s3.ap-south-1.amazonaws.com/20261007050423_titagarh-card.jpg",
    description:
      "MetalCloud digitised the foundry end to end — serial-level traceability, AI + IoT quality monitoring and real-time dashboards — lifting throughput 20–25% without an infrastructure overhaul.",
    sections: [
      {
        type: "highlights",
        items: [
          {
            iconImage: TgThroughput,
            iconFull: true,
            iconAlt: "",
            value: "20–25%",
            description: "increase in production throughput",
          },
          {
            iconImage: TgDelivery,
            iconFull: true,
            value: "15–20%",
            description: "faster and more reliable delivery cycles",
          },
          {
            iconImage: TgCost,
            iconFull: true,
            value: "5–8%",
            description: "reduction in production costs",
          },
          {
            iconImage: TgTraceability,
            iconFull: true,
            value: "100%",
            description: "serial-level traceability",
          },
          {
            iconImage: TgQuality,
            iconFull: true,
            value: "AI + IoT-enabled",
            description:
              "quality monitoring with automated defect detection, deviation alerts, and digital quality checkpoints",
          },
          {
            iconImage: TgEnergy,
            iconFull: true,
            value: "Real-time",
            description:
              "energy and safety monitoring with AI-based PPE compliance alerts and reduced power losses",
          },
        ],
      },
      {
        type: "text",
        heading: "Client Summary",
        content:
          "A leading global mobility and railway manufacturing company, operating across wagons, metro systems, and propulsion solutions, undertook a strategic initiative to modernise its foundry operations. The goal was a clear move from **manual, fragmented processes to a fully traceable, intelligence-driven manufacturing system** **without** a heavy infrastructure overhaul.",
      },
      {
        type: "text",
        heading: "Project Summary",
        content:
          "The client was facing operational challenges common in large-scale manufacturing environments, including limited real-time visibility, manual process dependency, inconsistent quality tracking, production bottlenecks, idle machine time, energy losses, and safety compliance gaps. The lack of end-to-end traceability and delayed decision-making impacted overall productivity, efficiency, and operational control.",
      },
      {
        type: "solutions",
        items: [
          {
            iconImage: TgWorkflow,
            iconFull: true,
            title: "End-to-end workflow",
            description:
              "digitisation from inward material handling to dispatch with serial-level traceability for every casting",
          },
          {
            iconImage: TgVisibility,
            iconFull: true,
            title: "Real-time visibility",
            description:
              "across production, quality, energy, and safety through centralized dashboards and automated MIS",
          },
          {
            iconImage: TgAiIot,
            iconFull: true,
            title: "AI + IoT-based",
            description:
              "monitoring for defect detection, deviation alerts, process analytics, and system-driven quality gates",
          },
          {
            iconImage: TgSafety,
            iconFull: true,
            title: "AI-enabled",
            description:
              "safety and energy optimisation through PPE compliance monitoring, real-time alerts, and power-loss tracking",
          },
        ],
      },
      {
        type: "testimonial",
        quote:
          "“Managing a business of this scale requires strong operational control and transparency. With MetalCloud, we have been able to make digitisation practical for our teams. Today, the entire production flow from raw material entry to inspection and quality checks is traceable. Real-time alerts and automated MIS have improved shop-floor visibility and helped us monitor performance more effectively.”",
        author: "Dy. MD & CEO",
      },
    ],
  },
];
